import React, { useState } from "react";
import { useNavigate } from 'react-router-dom';
import FilterContext from '@/FilterContext';
import useFilter from '@/hooks/useFilter';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort } from '@fortawesome/free-solid-svg-icons';

export default function TopPerformingOutreachMethodsExpanded() {
  const navigate = useNavigate();
  const filterContext = useFilter({});
  const [modal] = useState();
  const [hover, setHover] = useState(false);

  const data = [];

  /* sticky, LEFT-aligned header cells */
  const stickyThStyle = {
    position: 'sticky',
    top: 0,
    backgroundColor: '#F4F4F4',
    zIndex: 2,
    fontSize: '0.95rem',
    textAlign: 'left',
  };

  const HeadCell = ({ children, className = '' }) => (
    <th style={stickyThStyle} className={`py-2 text-start ${className}`} scope="col">
      <div className="d-inline-flex align-items-center justify-content-start gap-1">
        <span>{children}</span>
        <FontAwesomeIcon icon={faSort} style={{ color: '#2E2868', cursor: 'pointer', fontSize: '0.8em' }} />
      </div>
    </th>
  );

  return (
    <FilterContext.Provider value={filterContext}>
      {modal}
      <div className="container-fluid px-4 pt-5 pb-3 d-flex flex-column" style={{ minHeight: '100vh' }}>
        {/* Header: title left, filters + Close right */}
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h5 className="fw-semibold mb-0 ps-2" style={{ color: '#2E2868', fontSize: '1.4375rem', textAlign: 'left' }}>
            Top Performing Engagement Methods
          </h5>

          <div className="d-flex align-items-center gap-2">
            <select className="form-select form-select-sm w-auto">
              <option>Yesterday</option>
              <option>Last 7 Days</option>
              <option>Last 30 Days</option>
            </select>
            <select className="form-select form-select-sm w-auto">
              <option>Recruitment Sources</option>
              <option>Source A</option>
              <option>Source B</option>
            </select>
            <select className="form-select form-select-sm w-auto">
              <option>All Recruitment Sources</option>
              <option>Source A</option>
              <option>Source B</option>
            </select>

            <button
              className="btn btn-sm"
              style={{
                backgroundColor: '#2E2868',
                color: '#fff',
                border: 'none',
                borderRadius: '4px',
                padding: '6px 12px',
                boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
              }}
              onClick={() => navigate('/')}
            >
              ✕ Close
            </button>
          </div>
        </div>

        {/* Table */}
        <div className="border rounded-3 overflow-auto" style={{ maxHeight: 'calc(100vh - 150px)' }}>
          <table
            className="table table-sm table-borderless align-middle mb-0"
            style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.875rem'}}
          >
            <thead className="text-muted " style={{ height: '30px',   }}>
              <tr className="border-bottom">
                <HeadCell className="ps-3">Channel</HeadCell>
                <HeadCell className="text-start align-middle py-2 ps-3">Date</HeadCell>
                <HeadCell className="text-start align-middle py-2 ps-3">Answered/Opened Rate</HeadCell>
                <HeadCell className="text-start align-middle py-2 ps-3">Avg Response Time</HeadCell>
                <HeadCell className="text-start align-middle py-2 ps-3">Avg Response Rate</HeadCell>
              </tr>
            </thead>

            <tbody style={{ fontSize: '0.875rem' }}>
              {data.map((row, idx) => (
                <tr key={idx} className="border-bottom" style={{ height: '30px' }}>
                  <td className="text-start align-middle py-2 ps-3" style={{ borderRight: '1px solid #ccc', paddingRight: '12px' }}>{row.channel}</td>
                  <td className="text-start align-middle py-2 ps-3" style={{ borderRight: '1px solid #ccc', paddingRight: '12px', paddingLeft: '12px' }}>{row.date}</td>
                  <td className="text-start align-middle py-2 ps-3" style={{ borderRight: '1px solid #ccc', paddingRight: '12px', paddingLeft: '12px' }}>{row.answeredRate}</td>
                  <td className="text-start align-middle py-2 ps-3" style={{ borderRight: '1px solid #ccc', paddingRight: '12px', paddingLeft: '12px' }}>{row.avgResponseTime}</td>
                  <td className="text-start align-middle py-2 ps-3" style={{ paddingLeft: '12px' }}>{row.avgResponseRate}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </FilterContext.Provider>
  );
}
